<script setup>
import { ref, computed } from 'vue';
import BetCalcSelectionOdds from "@/components/bet_calc/BetCalcSelectionOdds.vue";
import BetCalcBetType from "@/components/bet_calc/BetCalcBetType.vue";
import BetCalcStake from "@/components/bet_calc/BetCalcStake.vue";
import BetCalcOddsType from "@/components/bet_calc/BetCalcOddsType.vue";

const stake = ref(10);
const oddsType = ref('decimal');
const betType = ref('stakeReturned');
const selections = ref([{ id: 1, odds: '2' }]);

const addSelection = () => {
  const newId = selections.value.length ? selections.value[selections.value.length - 1].id + 1 : 1;
  selections.value.push({ id: newId, odds: '2' });
};

const removeSelection = (id) => {
  if (selections.value.length > 1) {
    selections.value = selections.value.filter(selection => selection.id !== id);
  }
};

const result = computed(() => {
  const decimalOdds = selections.value.map(selection => parseFloat(selection.odds));
  if (decimalOdds.some(isNaN)) {
    return null;
  }
  const combinedOdds = decimalOdds.reduce((acc, val) => acc * val, 1);
  if (betType.value === 'stakeReturned') {
    return (stake.value * combinedOdds).toFixed(2);
  } else {
    return (stake.value * (combinedOdds - 1)).toFixed(2);
  }
});



const getSelectionLabel = (id) => {
  const sortedSelections = [...selections.value].sort((a, b) => a.id - b.id);
  const index = sortedSelections.findIndex(selection => selection.id === id);
  return `Selection ${index + 1} Odds:`;
};
</script>


<template>
  <div class="bet-calc-acca">
    <BetCalcOddsType v-model="oddsType"/>
    <BetCalcBetType v-model="betType"/>
    <BetCalcStake v-model="stake" style="margin: 0.5rem"/>

    <div v-for="selection in selections" :key="selection.id" class="selection-odds-container">
      <BetCalcSelectionOdds
        :oddsType="oddsType"
        @update:decimalOdds="value => selection.odds = value"
        style="margin: 1.5rem 0.5rem; flex: 1"
        :label="getSelectionLabel(selection.id)"
      />
      <button v-if="selections.length > 1"
              @click="removeSelection(selection.id)"
              class="remove-selection-btn">
        Remove
      </button>
    </div>

    <button @click="addSelection" class="add-selection-btn">Add Selection</button>

    <div class="bet-calc-acca-result" v-if="result">
      <h4 class="heading-medium">Bet Return: {{ result }}</h4>
    </div>
  </div>
</template>



<style scoped>
.bet-calc-acca {
  max-width: 576px;
  margin: 0 auto;
  padding: 20px;
  background-color: var(--clr-black-10);
}

.selection-odds-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.remove-selection-btn {
  background-color: red;
  color: white;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.25rem;
}

.add-selection-btn {
  background-color: green;
  color: white;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.25rem;
  margin: 1rem 0;
}

.bet-calc-acca-result {
  margin-top: 1rem;
}
</style>
